// extracted by mini-css-extract-plugin
export default {"a":"sponsors_a__laQZc","button":"sponsors_button__4uSvl","body":"sponsors_body__wo3Pr","main":"sponsors_main__53NjJ","no_website":"sponsors_no_website__FItIY"};